var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33,
    x: 16.875,
    y: 17,
    fill: "#BD7575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF78C7",
    d: "M9,49.9206814 C9,47.707202 10.7750001,45.6994337 12.9692715,45.4356406 L32.875,43.0425936 L52.7807285,45.4356406 C54.9728966,45.6991808 56.75,47.7006188 56.75,49.9206814 L56.75,62.0425936 L9,62.0425936 L9,49.9206814 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD95",
    d: "M26.6704545,41.4906185 C21.7663848,38.0068513 18.375,30.9212508 18.375,25.1331692 C18.375,17.1250403 24.8668711,10.6331692 32.875,10.6331692 C40.8831289,10.6331692 47.375,17.1250403 47.375,25.1331692 C47.375,30.9212508 43.9836152,38.0068513 39.0795455,41.4906185 L39.0795455,48.9058965 C39.0795455,48.9058965 34.8734611,50.8154815 32.875,50.8154815 C30.8765389,50.8154815 26.6704545,48.9058965 26.6704545,48.9058965 L26.6704545,41.4906185 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.875,
    cy: 28,
    r: 3,
    fill: "#FFDD95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.875,
    cy: 28,
    r: 3,
    fill: "#FFDD95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M16,27 L16,11.9911656 L16,11.9911656 C16,8.13005145 18.5416212,5 21.6716936,5 L44.3283064,5 C47.4606963,5 50,8.12869969 50,11.9911656 L50,27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#868686",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M39,45 L39,45 C48.9411255,45 57,36.9411255 57,27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 30,
    y: 44,
    stroke: "#5B68C0",
    strokeWidth: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    x: 56,
    y: 23,
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD7575",
    d: "M16.875,14.5 C16.875,10.9101491 19.7854073,8 23.3699533,8 L42.3800467,8 C45.9671104,8 48.875,10.9174538 48.875,14.5 L48.875,21 L32.875,15.079188 L16.875,21 L16.875,14.5 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 17,
    x: 47,
    y: 17,
    fill: "#5B68C0",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 17,
    x: 11,
    y: 17,
    fill: "#5B68C0",
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.0885b457b0f3ebda10e5a39868a80be0.svg";
export { ForwardRef as ReactComponent };